/**
 * Faceted Search - Async - Load more button
 */

(() => {
    const button_selector = '.js-htmx-faceted-search-load-more-button';
    let form = document.querySelector('.js-faceted-search-form');

    if (!form) {
        return;
    }

    function hide(button) {
        button.classList.add('-hidden');
    }

    function show(button) {
        button.classList.remove('-hidden');
    }

    function buttonClicked() {
        let button = document.querySelector(button_selector);

        if (!button) {
            return;
        }

        button.classList.add('-loading');
        button.setAttribute('title', button.getAttribute('data-loading'));
    }

    function updateButtonState(set_focus = false) {
        // console.log('Updating "Load more" button state...');

        let button = document.querySelector(button_selector);

        if (!button) {
            return;
        }

        button.classList.remove('-loading');

        let results = document.querySelector('.js-faceted-search-results');

        if (!results) {
            return;
        }

        let content = results.querySelector('.js-link-collection-content');

        if (!content) {
            hide(button);
            return;
        }

        const posts_total = parseInt(results.getAttribute('data-posts-total'));
        const posts_per_page = parseInt(
            results.getAttribute('data-posts-per-page')
        );
        const posts_displayed = content.childElementCount;

        const all_posts_displayed = posts_total <= posts_displayed;
        const not_multipage = posts_total <= posts_per_page;

        const current_page = Math.ceil(posts_displayed / posts_per_page);
        const previous_page = current_page - 1;

        if (set_focus) {
            // console.log('Setting focus...');

            const element_number = previous_page * posts_per_page + 1;

            document
                .querySelector(
                    '#search-results .js-link-collection-link' +
                        ':nth-child(' +
                        element_number +
                        ')'
                )
                ?.focus();
        }

        if (all_posts_displayed || not_multipage) {
            hide(button);
            return;
        }

        show(button);

        let input = button.querySelector(
            '.js-htmx-faceted-search-load-more-page-input'
        );

        if (!input) {
            return;
        }

        const next_page = current_page + 1;

        input.value = next_page;
    }

    function addButtonListeners() {
        let button = document.querySelector(button_selector);

        if (!button) {
            return;
        }

        button.addEventListener('click', (e) => {
            buttonClicked();
        });

        button.addEventListener('htmx:afterOnLoad', (e) => {
            H_Tools?.stickyheader?.makeBackwardsFocusable(
                document.querySelector('#search-results')
            );
            updateButtonState(true);
        });
    }

    function init() {
        form.addEventListener('htmx:afterOnLoad', (e) => {
            addButtonListeners();
            updateButtonState();
        });
        addButtonListeners();
        updateButtonState();
    }

    init();
})();
